/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect} from 'react';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import {getBasename} from '../utils/getBasename';
import LandingScreen from './landing-screen';
import AppScreen from './app-screen';
import {useSessionStorage} from 'react-use';
import {ANONYMOUS_ID_KEY, ANONYMOUS_ID_NAMESPACE} from './constants';

const EvAmpolAmpChargeApp: React.FC = () => {
  const pathname = window.location.pathname;
  const basename = getBasename(pathname);
  const searchParams = new URLSearchParams(window.location.search);
  const desktopAnonymousId = searchParams.get(ANONYMOUS_ID_KEY);

  const [_value, setValue] = useSessionStorage(
    ANONYMOUS_ID_NAMESPACE,
    desktopAnonymousId,
  );

  useEffect(() => {
    if (desktopAnonymousId) {
      setValue(desktopAnonymousId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [desktopAnonymousId]);

  return (
    <Router basename={basename}>
      <Switch>
        <Route exact strict path={`/`}>
          <LandingScreen />
        </Route>
        <Route path={`/app`}>
          <AppScreen />
        </Route>
        <Route exact path={`/customers`}>
          <LandingScreen isCustomers />
        </Route>
        <Route path={`/customers/app`}>
          <AppScreen isCustomers />
        </Route>
      </Switch>
    </Router>
  );
};

export default EvAmpolAmpChargeApp;
